module.exports = "/_next/static/images/software-development-banner-icon-bc5efa509355c5da9d3a4e7e7668f08d.webp";